export const iconFontAwesomeEditingGripLinesVertical = (
	<i className="fa-solid fa-grip-lines-vertical"></i>
);
